import { html } from 'lit';

export const closeIcon = html`
  <svg
    width="20"
    height="20"
    viewBox="0 0 13 12"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M.897.176L6.24 5.52 11.585.176l.512.512-5.344 5.344 5.344 5.344-.512.512L6.24 6.544.897 11.888l-.512-.512 5.344-5.344L.385.688z" />
  </svg>
`;

export const hamburgerIcon = html`
  <svg
    width="20"
    height="20"
    viewBox="0 0 11 9"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M.089 8.328h10.736v-.672H.089v.672zm0-3.552h10.736v-.672H.089v.672zm0-3.552h10.736V.552H.089v.672z" />
  </svg>
`;

export const backArrowIcon = html`
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M21 10.9957H5.41L9.7 6.70341C10.09 6.3132 10.09 5.68287 9.7 5.29266C9.31 4.90245 8.68 4.90245 8.29 5.29266L2.29 11.2959C2.2 11.3859 2.13 11.496 2.08 11.616C2.04 11.7161 2.02 11.8362 2.01 11.9462C2.01 11.9562 2 11.9762 2 11.9962C2 12.0263 2.01 12.0463 2.02 12.0763C2.03 12.1763 2.04 12.2864 2.08 12.3765C2.13 12.5065 2.2 12.6166 2.3 12.7066L8.3 18.7098C8.49 18.8999 8.74 19 9 19C9.26 19 9.51 18.8999 9.71 18.7098C10.1 18.3196 10.1 17.6893 9.71 17.2991L5.41 12.9968H21C21.55 12.9968 22 12.5465 22 11.9962C22 11.446 21.55 10.9957 21 10.9957Z" fill="currentColor"></path>
  </svg>
`;

export const chevronDownIcon = html`
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.7071 5.29289C13.0976 5.68342 13.0976 6.31658 12.7071 6.70711L8.70711 10.7071C8.31658 11.0976 7.68342 11.0976 7.29289 10.7071L3.29289 6.70711C2.90237 6.31658 2.90237 5.68342 3.29289 5.29289C3.68342 4.90237 4.31658 4.90237 4.70711 5.29289L8 8.58579L11.2929 5.29289C11.6834 4.90237 12.3166 4.90237 12.7071 5.29289Z" fill="currentColor"/>
  </svg>
`;

export const searchIcon = html`
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M20.4 17.6L16.9 14.1C17.6 12.9 18 11.5 18 10C18 5.6 14.4 2 10 2C5.6 2 2 5.6 2 10C2 14.4 5.6 18 10 18C11.5 18 12.9 17.6 14.1 16.9L17.6 20.4C18 20.8 18.5 21 19 21C19.5 21 20 20.8 20.4 20.4C21.2 19.6 21.2 18.4 20.4 17.6ZM10 16C6.7 16 4 13.3 4 10C4 6.7 6.7 4 10 4C13.3 4 16 6.7 16 10C16 13.3 13.3 16 10 16Z" fill="currentColor"></path>
  </svg>
`;
